<template>
    <div class="remote-select">
        <ESelect v-bind="$attrs" remote filterable @input="handleInput"
            :remote-method="isRemote ? remoteMethod : null" :loading="loading" style="flex: 1" :disabled="disabled"
            ref="select" @visible-change="handleVisibleChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </ESelect>
        <el-button v-if="isBatch" :disabled="disabled" class="ml20" type="primary" size="small"
            @click="handleBatchSelect">
            批量添加
        </el-button>
        <span style="display:inline-block; width: 10px;"></span>
        <Countdown v-if="isUpdate" @click="handleUpdateVenus" />
    </div>
</template>

<script>
import { batchSelectModal } from '@/components/modal/index.js'
import Countdown from '@/views/marketingManagement/configuration/components/countdown.vue'
import _ from 'lodash'
import { requestV3 } from '@/libs/ajax.js'
import busMixin from '@/views/mixins/busMixin'
export default {
    inheritAttrs: false,
    name: 'WkRemoteSelect',
    mixins: [busMixin],
    components: {
        Countdown
    },
    props: {
        isSearch: {
            type: Boolean,
            default: true
        },
        isRemote: {
            type: Boolean,
            default: true
        },
        isUpdate: {
            type: Boolean,
            default: false
        },
        isBatch: Boolean,
        disabled: Boolean,
        initial: String,
        rootFormData: Object,
        formState: {
            type: Object,
            default: null
        },
        fetch_type: {
            type: String,
            default: 'get'
        },
        fetch_url: {
            type: String,
            default: ''
        },
        update_url: {
            type: String,
            default: ''
        },
        update_type: {
            type: String,
            default: 'get'
        },
        params: {
            type: [Array, Object],
            default: () => {
                return {};
            }
        },
        plat_id: {
            type: String,
            default: ''
        },
        field: {
            type: String,
        }
    },
    data() {
        return {
            options: [],
            loading: false,
        }
    },
    computed: {
        dependencies() {
            return this.rootFormData && _.pick(this.rootFormData, this.params)
        },
        isDisabled() {
            return _.isEmpty(this.rootFormData.account_id) || _.isNull(this.rootFormData.account_id);
        }
    },
    watch: {
        dependencies: {
            handler(newVal, oldVal) {
                if (_.isEqual(newVal, oldVal)) {
                    return;
                }
                if (newVal && oldVal) {
                    this.$set(this.formState.payload, 'value', [])
                }
                this.options = []
                this.$nextTick(() => {
                    this.handleInitEffects()
                })
            },
            deep: true,
            immediate: true
        },
        isDisabled: {
            handler(newVal) {
                if (newVal) {
                    this.formState.payload.value = []
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        handleUpdateVenus() {
            if (!this.isUpdate) return
            const params = _.assign({}, this.dependencies, { plat_id: this.plat_id })
            const { update_url, update_type } = this;
            const fetch_api = update_type === 'get' ? requestV3({
                url: update_url,
                method: 'get',
                params,
            }) : requestV3({
                url: update_url,
                method: 'post',
                data: params,
            })
            this.$notify({
                type: 'success',
                title: '提示',
                message: '请求成功',
            })
            fetch_api.then(res => {
                this.$notify.closeAll()
                this.$notify({
                    type: 'success',
                    title: '提示',
                    message: '更新成功',
                })
                this.fetchData('')
            }).catch(err => {
                this.$notify.closeAll()
                this.$notify({
                    type: 'error',
                    title: '提示',
                    message: err.info,
                })
            })
        },
        handleVisibleChange(visible) {
            if (!visible) {
                this.fetchData('')
            }
        },
        handleBatchSelect() {
            const onSubmit = (data) => {
                let res_data = _.uniqBy(data)
                this.batchSelectModal(res_data, delErrList, vm)
            };
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: '输入或粘贴ID，每行一个',
                },
                cbs: {
                    onSubmit
                }
            })
        },
        remoteMethod: _.throttle(async function (search) {
            if (_.isEmpty(search)) {
                return;
            }
            await this.fetchData(search)
        }, 300),
        batchSelectModal(search, delErrList, vm) {
            let _this = this;
            const params = _.assign({}, this.dependencies, { search: search.join(',') })
            const { fetch_type, fetch_url } = this;
            const fetch_api = fetch_type === 'get' ? requestV3({
                url: fetch_url,
                method: 'get',
                params,
            }) : requestV3({
                url: fetch_url,
                method: 'post',
                data: params,
            })
            fetch_api.then(res => {
                let res_options = res.data?.list.splice(0, 200) || [];
                if (res.data?.err_list?.length) {
                    let err_list = res.data?.err_list || [];
                    delErrList({
                        tip: `未找到以下产品，请检查输入的ID是否准确，或检查是否已经绑定至目标账户对应客户且是启用状态，是否需要剔除未找到的产品？`,
                        list: err_list,
                        onOk() {
                            _this.cbList(res_options);
                            vm.close()
                        },
                        colse() { }
                    })
                } else {
                    _this.cbList(res_options);
                    vm.close()
                }
            })

        },
        cbList(list) {
            // 取出已经存在的产品
            this.options = _.uniqBy([...this.options, ...list], 'value')
            this.formState.payload.value = _.uniq(_.concat(this.formState.payload.value, list.map(item => item.value)))

            // 为了取点汉字用  其它啥也没干 !this.formState.payload.props.defaultData?.length && 
            if (Array.isArray(this.rootFormData[this.formState.payload.field])) {
                this.$set(this.formState.payload.props, 'defaultData', this.options.filter(item => this.formState.payload.value.includes(item.value)))
            }
        },
        async fetchData(search) {
            this.loading = true;
            const params = _.assign({}, this.dependencies, { search })
            const { fetch_type, fetch_url } = this;
            const res = await (fetch_type === 'get' ? requestV3({
                url: fetch_url,
                method: 'get',
                params,
            }) : requestV3({
                url: fetch_url,
                method: 'post',
                data: params,
            }))
            if (res?.code != 200) {
                return this.$message.error(res?.info || '获取数据失败')
            }
            this.options = res.data?.list || [];
            // 为了取点汉字用  其它啥也没干
            if (Array.isArray(this.rootFormData[this.formState.payload.field])) {
                this.$set(this.formState.payload.props, 'defaultData', this.options.filter(item => this.formState.payload.value.includes(item.value)))
            }
            this.loading = false;
        },
        // 处理当前表单项依赖的表单项值变化，如果当前字段有默认值，直接走接口赋值
        handleInitEffects() {
            if (!_.isNull(this.rootFormData[this.formState.payload.field]) && !_.isEmpty(this.rootFormData[this.formState.payload.field])) {
                let value = Array.isArray(this.rootFormData[this.formState.payload.field]) ? this.rootFormData[this.formState.payload.field].join(',') : this.rootFormData[this.formState.payload.field];
                this.fetchData(this.isSearch ? value : '')
                return;
            }
            this.fetchData('')
        },
        handleInput(val) {
            // 为了取点汉字用  其它啥也没干
            const values = _.toArray(val)
            const defaultValue = _.filter(this.formState.payload.props.defaultData || [], (item) => values.includes(item.value));
            const options = this.options;
            const list = _.differenceBy(options, defaultValue, 'value');
            this.formState.payload.props.defaultData = _.concat(_.filter(list, (item) => values.includes(item.value)), defaultValue)
            this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss" scoped>
.remote-select {
    display: flex;
    align-items: center;
}
</style>